module.exports = __webpack_public_path__ + "img/photosnap.3f34b49c.svg";